// extracted by mini-css-extract-plugin
export default {"currency":"ModalBonus_currency__aP-++","itemsContainer":"ModalBonus_itemsContainer__VQdFa","item":"ModalBonus_item__vT72D"};